import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function AboutTeaser() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs md:text-sm font-medium text-accent-600 uppercase tracking-widest mb-6">
            {t('about.title')}
          </p>

          <p className="text-sm md:text-base lg:text-lg text-foreground-700 leading-relaxed md:leading-loose">
            {t('about.text')}
            <span className="text-accent-500 ml-1">✦</span>
          </p>

          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-sm font-semibold text-foreground-800 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
            >
              Learn more about Texio
              <i className="ri-arrow-right-line text-sm"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}